import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GameService, InternationalizationService, SessionService, User } from '@app/core/services';

@Component({
    selector: 'jeopardy-profiles',
    templateUrl: './profiles.component.html',
    styleUrls: ['./profiles.component.scss'],
    imports: [RouterLink]
})
export class ProfilesComponent implements OnInit {
  profiles: User[];
  profileIndex: number;
  currentProfile: User;

  private sessionSevice = inject(SessionService);
  private router = inject(Router);
  private gameService = inject(GameService);
  public i18n = inject(InternationalizationService);

  ngOnInit(): void {
    this.currentProfile = this.sessionSevice.getUser();
    this.profileIndex = 0;
    this.profiles = this.sessionSevice.getProfilesHistory();
  }

  public skipProfile(event: MouseEvent, direction: 'left' | 'right') {
    event.preventDefault();
    const nextIndex = this.profileIndex + (direction === 'right' ? 1 : -1);
    this.profileIndex = Math.max(0, Math.min(nextIndex, this.profiles.length - 1));
  }

  public selectProfile(event: MouseEvent) {
    event.preventDefault();
    const profile = this.profiles[this.profileIndex];

    if (!profile) {
      return;
    }

    this.sessionSevice.setUser(profile, false);
    this.sessionSevice.setLocation(profile.location);

    if(profile.activeGame) {
      this.gameService.setGameId(profile.activeGame || null);
    }
    
    this.router.navigate(['main-menu']);
  }

  public removeProfile(event: Event, profile: User) {
    event.preventDefault();

    this.profiles = this.sessionSevice.removeProfile(profile.id);
    this.profileIndex = Math.max(0, Math.min(this.profileIndex, this.profiles.length - 1));

    if(this.profiles.length === 0) {
      this.router.navigate(['select-language']);
    }
  }
}
